export default "__VITE_ASSET__BEXIy8fX__"